import { render, staticRenderFns } from "./DeleteCoursePopup.vue?vue&type=template&id=c7be4880&"
import script from "./DeleteCoursePopup.vue?vue&type=script&lang=js&"
export * from "./DeleteCoursePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports